import React from "react";

import { Button, Col, Container, Image, Row } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { trackEvent } from "@/components/GA.component";
import { ReserveProvider } from "@/context/ReserveProvider.context";
import { getUrlLangPrefix } from "@/utils/Local";

import BannerComponent from "../components/Banner.component";
import DocumentComponent from "../components/Document.component";
import ReserveModalComponent from "../components/reserve/ReserveModal.component";
import i18n from "../i18n";

const Shop = () => {
  const { t } = i18n;
  const langPrefix = getUrlLangPrefix();

  const items = [
    {
      title: t("_shop.pakvert_panels.title"),
      description: t("_shop.pakvert_panels.description"),
      image: "/images/shop/pakvert.webp",
      url: `${langPrefix}/${t("_route.shop")}/pakvert`,
      btn_label: t("_shop.pakvert_panels.btn_label"),
    },

    {
      title: t("_shop.pakville.title"),
      description: t(
        "Reserve your place in line for $500.00 and join the innovators embracing PakVille’s sustainable, long-lasting homes. Your reservation fee is fully refundable until you confirm your order. Model selection comes later—no pressure.",
      ),
      image: "/images/shop/reserve.webp",
      url: `${langPrefix}/${t("_route.contact-us")}`,
      btn_label: t("_shop.pakville.btn_label"),
      show_reservation: true,
    },
  ];

  return (
    <React.Fragment>
      <DocumentComponent title={t("shop")} />

      <BannerComponent description={t("shop_description")} title={t("shop")} />

      <Container>
        <Row>
          <Col xs={{ span: 10, offset: 1 }}>
            <div className="d-flex flex-column flex-lg-row justify-content-center gap-5 mb-5">
              {items.map((item) => {
                if (item.show_reservation) {
                  return (
                    <div
                      key={item.title}
                      className="d-flex flex-column text-start gap-2 w-100"
                    >
                      <Image
                        alt={item.title}
                        className="rounded m-auto mt-0 mb-2 mw-100"
                        src={item.image}
                      />

                      <h2 className="fs-4">{item.title}</h2>
                      <p>{item.description}</p>

                      <ReserveProvider>
                        <ReserveModalComponent btnClass=" mt-auto" />
                      </ReserveProvider>
                    </div>
                  );
                }

                return (
                  <div
                    key={item.title}
                    className="d-flex flex-column text-start gap-2 w-100"
                  >
                    <NavLink to={item.url}>
                      <Image
                        alt={item.title}
                        className="rounded m-auto mt-0 mb-2 mw-100"
                        src={item.image}
                      />
                    </NavLink>

                    <h2 className="fs-4">{item.title}</h2>
                    <p>{item.description}</p>

                    <NavLink
                      style={{ marginTop: "auto" }}
                      to={item.url}
                      onClick={() => {
                        trackEvent("shop_click");
                      }}
                    >
                      <div className="d-grid gap-2 mt-3">
                        <Button variant="primary mt-auto">
                          <span>{item.btn_label}</span>
                        </Button>
                      </div>
                    </NavLink>
                  </div>
                );
              })}
            </div>
          </Col>
        </Row>
      </Container>
    </React.Fragment>
  );
};

export default Shop;
